/* esm.sh - applesauce-react@5.1.0/dist/helpers/build-link-renderer */
export * from "/*applesauce-react@5.1.0/esnext/dist/helpers/build-link-renderer.mjs";
